export enum RequestTypes {
  Onboarding = 'Onboarding',
  PartnerRegistr = 'PartnerRegistr',
  Contract = 'Contract',
  Exception = 'Exception',
  Retail = 'Retail',
  RetailException = 'RetailException',
  RetailOnboarding = 'RetailOnboarding',
  BPRegistration = 'BPRegistration',
  SimplePartnerRegistration = 'SimplePartnerRegistration',
  BPReconfirmation = 'BPReconfirmation',
}

export interface PartialBPRegistrationData {
  id: string
  partnerId: string
  partnerCountry: string
  partnerLegalName: string
  contactID: string
  contactFirstName: string
  contactLastName: string
  email: string
  status: RequestStatus | OldRequestStatus
  enrollmentStart: string
  welcomeEmailSentDate: string
  type: 'old' | 'new'
}

export enum EActionStatus {
  New = 'New',
  WIP = 'WIP',
  Done = 'Done',
  Rejected = 'Rejected',
  Processing = 'Processing',
  NADone = 'NADone',
  Waiting = 'Waiting',
  Error = 'Error',
}

export const ActionStatusMap = {
  Done: 'Ended',
  WIP: 'Started',
  NADone: 'Not needed',
  New: 'Not started',
  Error: 'Error',
  Rejected: 'Rejected',
  Waiting: 'Waiting',
  Processing: 'Processing',
}

export enum RequestStatus {
  New = 'New',
  Done = 'Done',
  Rejected = 'Rejected',
}

export enum OldRequestStatus {
  IncompleteRegistration = 'Incomplete Registration',
  PendingTC = 'Pending-T&C',
  NotEligibleForBPProgram = 'Not Eligible for Business Partner Program',
  PartnerNotInterested = 'Partner Not Interested',
  ContactNotInterested = 'Contact Not Interested',
  NotUsable = 'Not-Usable',
  RejectedTM = 'Rejected - TM',
  PartnerIdentificationWithProfiling = 'Partner Identification with Profiling',
  PartnerIdentificationWithAgent = 'Partner Identification with Agent',
  PartnerIdentificationWithSupervisor = 'Partner Identification with Supervisor',
  ContactIdentificationWithProfiling = 'Contact Identification with Profiling',
  ContactIdentificationWithAgent = 'Contact Identification with Agent',
  ContactIdentificationWithSupervisor = 'Contact Identification with Supervisor',
  CompleteRecordPendingUpload = 'Complete record pending upload',
  CompleteRecordPendingRefresh = 'Complete record pending refresh',
  WelcomeEmailSent = 'Welcome eMail Sent',
}

export enum OnbPageURLs {
  OnboardingSpecialization = 'specializations-1595588657472',
  RetailExceptionAdmin = 'retail-exceptions-admin',
  RequestDetail = 'request-detail',
  RetailException = 'retail-exceptions',
  Exception = 'commercial-exceptions',
  RetailOnboardingSpecialization = 'onboarding-retail-specialization',
  RetailOnboardingDetail = 'onboarding-retail-detail',
  RetailHybridOnboardingDetail = 'onboarding-hybrid-detail',
  BPRegitrationSpecialization = 'bp-registration-specialization',
  ContractRequests = 'contract-requests',
  OnboardingRequest = 'onb-requests',
  RetailRegistration = 'retail-requests',
  OnboardingRetail = 'onboarding-retail',
  Onboarding = 'onboard',
  BPRegistration = 'bp-registration',
  BPRegistrationRequests = 'bp-registration-requests',
  SimplePartnerRegistration = 'simple-partner-registration',
  SimplePartnerRegistrations = 'simple-partner-registrations',
  BPReconfirmations = 'bp-reconfirmations',
  BPReconfirmation = 'bp-reconfirmation',
  TermsAndConditions = 'terms-and-conditions',
  DistributorOnBehalfUpdate = 'distributors-on-behalf-update',
}

export enum OnboardingSources {
  PortalIntegration = 'PortalIntegration',
  Onboarding = 'Onboarding',
  OnboardingContract = 'Onboarding Contract',
  BPRegistration = 'Onboarding BPRegistration',
  RetailOnboarding = 'Onboarding RetailOnboarding',
}

export enum ENotificationTemplate {
  RejectRequest = 'A112AE0B-1E00-4581-ACB2-84AB238F15FA',
  RejectContractRequest = '44e461f4-0f06-45ee-9372-e96c656cfb22',
  RejectExceptionRequest = '9e66721e-138e-41fe-ac17-b528257b567a',
}

export const isCompletedStatus = (status: EActionStatus) => {
  return [EActionStatus.Done, EActionStatus.NADone].includes(status)
}
